import BaseModule from '@/store/modules/base.module'
var baseModule = new BaseModule('video')

const state = {
  ...baseModule.state
}
const mutations = {
  ...baseModule.mutations
}
const actions = {
  ...baseModule.actions
}
const getters = {
  ...baseModule.getters
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/video.module.js